import React from 'react';

type SvgsettingsProps = React.SVGProps<SVGSVGElement>;

const Svgsettings: React.FC<SvgsettingsProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.54583 3.09119C10.0428 1.04252 12.9572 1.04252 13.4542 3.09119C13.6054 3.71542 14.0457 4.22988 14.6391 4.47572C15.2325 4.72157 15.9076 4.66922 16.456 4.33485C18.2562 3.23819 20.3177 5.29852 19.221 7.09985C18.8871 7.64802 18.8349 8.32262 19.0804 8.91563C19.326 9.50864 19.8398 9.94886 20.4635 10.1005C22.5122 10.5975 22.5122 13.5119 20.4635 14.0089C19.8393 14.1601 19.3248 14.6004 19.079 15.1938C18.8331 15.7872 18.8855 16.4623 19.2198 17.0107C20.3165 18.8109 18.2562 20.8724 16.4548 19.7757C15.9067 19.4418 15.2321 19.3896 14.6391 19.6351C14.046 19.8807 13.6058 20.3945 13.4542 21.0182C12.9572 23.0669 10.0428 23.0669 9.54583 21.0182C9.39458 20.394 8.95429 19.8795 8.36091 19.6336C7.76752 19.3878 7.0924 19.4402 6.544 19.7745C4.74383 20.8712 2.68233 18.8109 3.779 17.0095C4.11289 16.4614 4.1651 15.7868 3.91955 15.1937C3.674 14.6007 3.16017 14.1605 2.5365 14.0089C0.487833 13.5119 0.487833 10.5975 2.5365 10.1005C3.16074 9.94927 3.67519 9.50898 3.92104 8.91559C4.16688 8.32221 4.11453 7.64709 3.78017 7.09869C2.6835 5.29852 4.74383 3.23702 6.54517 4.33369C7.71183 5.04302 9.22383 4.41535 9.54583 3.09119Z"
      fillRule="evenodd"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <circle
      cx="11.5"
      cy="12.0547"
      r="3.5"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default Svgsettings;
